import React from "react";
import { Carousel } from "react-responsive-carousel";

import Icon from "../Icon";
import Button from "../Button";
import Modal from "../Modal";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./index.scss";

export default class DemoCarousel extends React.Component{
  constructor(props) {
    super(props);

    this.state = {
      value: 0,
      modal: false
    };
  }

  componentDidMount(){
    document.addEventListener("updateMapCarousel", this.updateCarousel, false);
  }

  componentDidUpdate(){
    if ( this.props.children.length < this.state.value ){
      this.onChange(0);
    }
  }

  componentWillUnmount() {
    document.removeEventListener("updateMapCarousel", this.updateCarousel, false);
  }

  updateCarousel = (e) => {
    if (e.detail && e.detail.selectedNumber !== undefined && e.detail.from !== "carousel" && e.detail.from !== "supplier"){
        this.setState({ value: e.detail.selectedNumber })
    }
  }

  onChange = (value) => {
    this.setState({ value }, () => {
      let event = new CustomEvent("updateMapCarousel", 
        { 
          "detail": 
          {
            "selectedNumber": this.state.value,
            "from": "carousel"
          } 
        }
      )
      document.dispatchEvent(event);
    })
  };

  render() {
    const { state, onChange, props } = this;
    const { children, options, galleryButton, length } = props;
    const { value, modal } = state;

    const defaultOptions = {
        showArrows : true,
        showStatus : false,
        showIndicators : false,
        infiniteLoop : false,
        showThumbs : true,
        useKeyboardArrows : true,
        autoPlay : false,
        stopOnHover : true,
        swipeable : true,
        dynamicHeight : false,
        emulateTouch : true,
        centerMode : true,
        centerSlidePercentage : 100,
        swipeScrollTolerance: 5
    }

    const configOptions = {
        ...defaultOptions,
        ...options
    }

    let className = `carousel ${props.className}`
    return (
      <div className={className}>
            {/* the statusFormatter didn't allow me to pass an HTML element, so needed this hack... */}
            { galleryButton && 
                <Button onClick={() => this.setState({ modal: true })} className="galleryButton">
                    {`${value + 1}/${length}`}
                </Button>      
            }
          <Carousel
              selectedItem={value}
              onChange={onChange}
              {...configOptions}
              renderArrowPrev={(onClickHandler, hasPrev, label) =>
                  hasPrev && (
                      <button className="prev" type="button" onClick={(e) => { e.stopPropagation(); onClickHandler(); }} title={label}>
                          <Icon icon={"arrow-text-link-left"} size={14} />
                      </button>
                  )
              }
              renderArrowNext={(onClickHandler, hasNext, label) =>
                  hasNext && (
                      <button className="next" type="button" onClick={(e) => { e.stopPropagation(); onClickHandler(); }} title={label} >
                          <Icon icon={"arrow-text-link-right"} size={14} />
                      </button>
                  )
              }
              thumbWidth={125}
              renderThumbs={()=> children}
              onClickItem={() => { if(galleryButton) this.setState({ modal: true }) }}
              >
              {children}
          </Carousel>
          <Modal
            backDropClassName="backDrop"
            open={modal}
            className="galleryModal"
            closeFn={() => this.setState({ modal: false })}
            closeOnBackDrop={true}
            footerContent={
                <div onClick={() => this.setState({ modal: false })} className="bottomFixed">
                    <Icon icon="feather-x" /> Close
                </div>
            }
        >
            <div className="body">
              {children}
            </div>
        </Modal>                        
      </div>
      
    );
  }
}
